import { Component, ViewChild, Input, OnChanges } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Activo } from "../../../core/modelos/activo";
import { Fichero } from '../../../core/modelos/fichero';
import { Cliente } from '../../../core/modelos/cliente';
import { User } from '../../../core/modelos/user';
import { SimpleChanges } from "@angular/core/src/metadata/lifecycle_hooks";
import { FileManagerService } from "../../content/file-manager/file-manager.service";
import { PdfModalService } from '../../../core/pdf-modal/pdf-modal.service';
import { SimpleListComponent } from "../simple-list/simple-list.component";
import { TicketsService } from "../tickets/tickets.service";
import { NotificacionesService } from "../../../core/notificaciones/notificaciones.service";
import { NgxGalleryOptions, NgxGalleryComponent, NgxGalleryImage, NgxGalleryImageSize, NgxGalleryAnimation } from 'ngx-gallery';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ObservableMedia } from "@angular/flex-layout";

@Component({
  selector: "fuse-stats",
  templateUrl: "./stats.component.html",
  styleUrls: ["./stats.component.scss"]
})
export class StatsComponent {
  listStats: Array<Object>;
  childLists: any;
  verDetalle: boolean = false;

  // Variables nuevas para la visualizacion dentro de la app
  pdf;
  imagen;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  usuarioLogueado: User;
  clienteSeleccionado: Cliente;

  @ViewChild(SimpleListComponent) list: SimpleListComponent;
  @ViewChild(NgxGalleryComponent) galeria: NgxGalleryComponent;

  @Input() indexSeleccion: number;
  @Input() itemSeleccion: Activo;

  constructor(
    private router: Router,
    private fileManagerService: FileManagerService,
    private ticketsService: TicketsService,
    private notificaciones: NotificacionesService,
    private pdfModalService: PdfModalService,
    private http: HttpClient,
    private media: ObservableMedia,
  ) {
    this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.verDetalle = false;
        this.search();
      }
    });

    this.usuarioLogueado = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
    this.clienteSeleccionado = this.usuarioLogueado.cliente;
    this.listStats = [];
    this.childLists = {
      reporting: {
        title: this.notificaciones.mensajes.IdiomaActual.Dashboard.Reporting,
        items: [],
        folder: "Reporting"
      },
      built: {
        title: this.notificaciones.mensajes.IdiomaActual.Dashboard.Built,
        items: [],
        folder: "As-Built"
      }
    };

    this.search();
  }

  search() {
    if (!this.itemSeleccion) {
      // this.getTickets();
      // this.getDocs();
    } else {
      // this.getTicketsActivo();
      this.getDocsActivo();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSeleccion) {
      this.verDetalle = true;
      this.itemSeleccion = changes.itemSeleccion.currentValue;
      this.search();
    }
  }

  // getTickets() {
  //     this.ticketsService.getTickets().subscribe(
  //         data => {
  //             if (data.success) {
  //                 this.childLists.tickets.items = data.items;
  //                 this.childLists.tickets.items.map((t) => {
  //                   t.date = t.created_at
  //                   t.name = t.titulo
  //                 })
  //             } else {
  //                 // CONTROLAR ERROR
  //                 this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.SinTickets);
  //             }
  //         },
  //         err => {
  //             // CONTROLAR ERROR
  //             this.notificaciones.errorServidor(err.status);
  //         }
  //     );
  // }

  // getTicketsActivo() {
  //     this.ticketsService.getTicketFromActivo(this.itemSeleccion.id).subscribe(
  //         data => {
  //             if (data.success) {
  //                 this.childLists.tickets.items = data.items
  //                 this.childLists.tickets.items.map((t) => {
  //                   t.date = t.created_at
  //                   t.name = t.titulo
  //                 })
  //             } else {
  //                 // CONTROLAR ERROR
  //                 this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.SinTickets);
  //             }
  //         },
  //         err => {
  //             // CONTROLAR ERROR
  //             this.notificaciones.errorServidor(err.status);
  //         }
  //     );
  // }

  getDocs() {
    const vm = this;
    this.fileManagerService.getAllFiles().send(function(err, data) {
      if (!err) {
        const ficherosCategorizados = FileManagerService.categorizarFicheros(data);
        ficherosCategorizados.sort((a, b) => +new Date(b.lastmodified) - +new Date(a.lastmodified));

        vm.childLists.reporting.items = ficherosCategorizados;
        vm.childLists.reporting.items.map(t => {
          t.date = t.lastmodified;
        });
      }
    });
  }

  getDocsActivo() {
    const vm = this;
    this.fileManagerService.getFilesDeActivo(this.itemSeleccion, this.childLists.reporting.folder).send(function(err, data) {
      if (!err) {
        let ficherosCategorizados = FileManagerService.categorizarFicheros(data);

        ficherosCategorizados.sort((a, b) => +new Date(b.lastmodified) - +new Date(a.lastmodified));

        vm.childLists.reporting.items = ficherosCategorizados;
        vm.childLists.reporting.items.map(t => {
          t.date = t.lastmodified;
        });
      }
    });
    this.fileManagerService.getFilesDeActivo(this.itemSeleccion, this.childLists.built.folder).send(function(err, data) {
      if (!err) {
        let ficherosCategorizados = FileManagerService.categorizarFicheros(data);

        ficherosCategorizados.sort((a, b) => +new Date(b.lastmodified) - +new Date(a.lastmodified));

        vm.childLists.built.items = ficherosCategorizados;
        vm.childLists.built.items.map(t => {
          t.date = t.lastmodified;
        });
      }
    });
  }

  verDashboard(activoSeleccionado: Activo) {
    this.router.navigate(["/dashboard", activoSeleccionado.id]);
  }

  goTickets(seleccion: Activo) {
    this.router.navigate(["/tickets", seleccion.id]);
  }

  goToDocs(seleccion: Activo, folder?: string) {
    if (seleccion.carpetaAWS) {
      this.fileManagerService.setCarpetaDestino(`${seleccion.carpetaAWS}${folder !== undefined ? '/' + folder : ''}`);
      this.router.navigate(["/docs", seleccion.id]);
    } else {
      // Mostrar error
      alert("El activo no tiene carpeta asociada");
    }
  }

  goToViewer(seleccion: Activo) {
    this.router.navigate(["/3d-viewer", { enlace: seleccion.enlace, id: seleccion.id }], { skipLocationChange: true });
  }

  goPowerBi(url: string, descripcion: string, idActivo: number, idDashboard: number) {
    // this.router.navigate(['/power-bi', url]);
    this.router.navigate(["/power-bi", { url: url, descripcion: descripcion, idActivo: idActivo, idDashboard: idDashboard }], {
      skipLocationChange: true
    });
  }

  reiniciarVariablesDeVisualizacion() {
      this.pdf = null;
      this.imagen = false;
  }

  vistaPrevia(fichero: Fichero) {
    // Get the most recent version, if any
    const versions = fichero.versions || []
    const { VersionId = null } = versions.find(r => r.LastModified.getTime() === Math.max.apply(null, versions.map(a => a.LastModified))) || {}

    this.reiniciarVariablesDeVisualizacion();
    const component = this;
    if (fichero.type === 'pdf') {
        this.fileManagerService.getOptionToPrint(fichero.key, VersionId).send(
            function (err, data) {
                if (err) {
                    console.log(err);
                    return;
                }
                const blob = new Blob([data.Body], {
                    type: 'application/pdf'
                });
                const blobUrl = URL.createObjectURL(blob);
                // component.pdf = blobUrl;
                // window.open(blobUrl);
                component.pdfModalService.openModal(blobUrl);
            }
        );

    }
    else if (fichero.type === 'image') {
        this.fileManagerService.getOptionToPrint(fichero.key, VersionId).send(
            function (err, data) {
                if (err) {
                    console.log(err);
                    return;
                }
                const blob = new Blob([data.Body], { type: '' });
                const blobUrl = URL.createObjectURL(blob);
                component.galleryImages = [
                    {
                        small: blobUrl,
                        medium: blobUrl,
                        big: blobUrl,
                        description: fichero.name
                    }
                ];
                component.galleryOptions =
                    [
                        {
                            'arrowPrevIcon': '',
                            'arrowNextIcon': '',
                            'thumbnails': false,
                            'thumbnailsArrows': false,
                            'thumbnailsMoveSize': 4,
                            'imageArrows': false,
                            'imageInfinityMove': true,
                            'imageAutoPlay': true,
                            'imageAutoPlayInterval': 5000,
                            'imageAutoPlayPauseOnHover': true,
                            'previewAutoPlay': false,
                            'previewInfinityMove': true,
                            'previewFullscreen': false,
                            'previewCloseOnClick': true,
                            'previewCloseOnEsc': true,
                            'previewZoom': true,
                            'previewRotate': true,
                            'width': '100%',
                            'height': '600px',
                            'imageSize': NgxGalleryImageSize.Contain,
                            'imageAnimation': NgxGalleryAnimation.Slide,
                            'thumbnailSize': NgxGalleryImageSize.Contain,
                            'previewDescription': true,
                            'imageDescription': true,
                            'imagePercent': 100,
                        },

                        {
                            'breakpoint': 500,
                            'height': '200px',
                            // 'thumbnailsColumns': 3
                        },

                        {
                            'breakpoint': 300,
                            'height': '100px',
                            // 'thumbnailsColumns': 2
                        },
                    ];
                component.imagen = true;
                // Se abre la galería
                setTimeout(() => {
                    component.galeria.openPreview(0);
                }, 0);

            }
        );
    }
  }

  // This is temporary
  actualizarModelo() {
    const link = this.itemSeleccion.enlace;
    if(link.length === 0) {
      console.log('Missing URL for current asset');
      return;
    }
    const noParamsURL = link.split('&')[0].split('?')[0].split('/');

    if(noParamsURL.length < 6) {
      console.log('Invalid URL: ', noParamsURL);
      return;
    }

    const projectId = noParamsURL[4];
    const itemId = noParamsURL[5];
    const url = `https://bimux.revers3d.com/api/update-parameters-pdfs/${projectId}/${itemId}`;

    const formData: FormData = new FormData();
    formData.append('code', this.itemSeleccion.codigo);
    formData.append('bucket', this.clienteSeleccionado.bucketAWS);
    formData.append('gimXls', `${this.itemSeleccion.carpetaAWS}/Actualización Datos/Mantenimiento.xls`);
    formData.append('yardiXlsx', `${this.itemSeleccion.carpetaAWS}/Actualización Datos/Ocupacion.xlsx`);
    this.http.post(url, formData).subscribe(
      (response) => console.log(response),
      (error) => console.log(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/stats/stats.component.ts